import * as React from 'react'
import { Badge, badges } from '@amzn/dvui/dist/Badge'

export interface IRuntimeBadgeProps {
  runtime?: string
}

export const Runtime = ({ runtime }: IRuntimeBadgeProps) => (
  runtime &&
    (<Badge use={badges.TEXT}>
      <span data-automation-id="runtime-badge">{runtime}</span>
    </Badge>) || null
)
